// Keep phone text intact so the server can show and report corrections.
export function parseContactCsv(text) {
  const records = [];
  let cells = [], field = '', quoted = false, line = 1, rowNumber = 1;
  const finishRecord = () => {
    cells.push(field);
    if (cells.some(cell => cell.trim())) records.push({ cells, rowNumber });
    cells = [];
    field = '';
  };

  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    if (char === '"') {
      if (quoted && text[i + 1] === '"') { field += '"'; i++; }
      else quoted = !quoted;
    } else if (char === ',' && !quoted) {
      cells.push(field);
      field = '';
    } else if ((char === '\n' || char === '\r') && !quoted) {
      finishRecord();
      if (char === '\r' && text[i + 1] === '\n') i++;
      line++;
      rowNumber = line;
    } else {
      field += char;
      if (char === '\n') line++;
    }
  }
  if (field || cells.length) finishRecord();
  if (records.length < 2) return [];

  const headers = records[0].cells.map(cell => cell.trim().replace(/^\uFEFF/, '').toLowerCase());
  const read = (record, names) => {
    const index = headers.findIndex(header => names.includes(header));
    return index === -1 ? '' : (record.cells[index] || '').trim();
  };

  return records.slice(1).map(record => ({
    rowNumber: record.rowNumber,
    name: read(record, ['name', 'full name', 'full_name']),
    phone: read(record, ['phone', 'phone number', 'phone_number', 'mobile', 'whatsapp']),
    countryCode: read(record, ['country_code', 'country code', 'cc']),
    email: read(record, ['email', 'email address', 'email_address']),
  }));
}
